import { createFileRoute } from '@tanstack/react-router';

import { Debug } from 'components/Debug/Debug';

export const Route = createFileRoute('/debug/$id')({
  component: Debug,
});
